(function () {
  var configEl = document.getElementById("cp-config");
  if (!configEl) return;

  var config = {};
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
  if (!config.productId) return;

  var PRODUCT_ID = String(config.productId);
  var LABEL      = config.label || "Item Personalization";    // used to find the row in DOM
  var FEE_LABEL  = config.feeLabel || config.label;           // shown in the fee line
  var CURRENCY   = config.currencySymbol || "£";
  var FEE_ID     = "cp-fee-line";
  var FEE_ID_DR  = "cp-fee-line-drawer";

  // ── Cart helpers ──────────────────────────────────────────────────────────

  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); });
  }

  function formatMoney(cents) {
    return CURRENCY + (cents / 100).toFixed(2);
  }

  // ── Process cart ──────────────────────────────────────────────────────────

  function process() {
    getCart().then(function (cart) {
      var items = cart.items || [];

      // Find personalization items and their 1-based line indices
      var personalLines = [];
      items.forEach(function (item, idx) {
        if (String(item.product_id) === PRODUCT_ID) {
          personalLines.push({ item: item, index: idx + 1 });
        }
      });

      if (personalLines.length === 0) {
        removeFeeLine(FEE_ID);
        removeFeeLine(FEE_ID_DR);
        return;
      }

      var totalCents = personalLines.reduce(function (sum, l) {
        return sum + l.item.line_price;
      }, 0);

      // ── Hide personalisation rows (cart page + drawer) ────────────────
      // Find the <a> leaf whose text exactly matches the product label,
      // then walk up to the TR (cart page) or CartDrawerItem div (drawer)

      document.querySelectorAll("a").forEach(function (a) {
        if (a.childElementCount !== 0) return;
        if (a.textContent.trim() !== LABEL) return;

        var node = a.parentElement;
        while (node && node !== document.body) {
          if (node.tagName === "TR") {
            node.style.setProperty("display", "none", "important");
            break;
          }
          if (node.id && node.id.indexOf("CartDrawerItem-") === 0) {
            node.style.setProperty("display", "none", "important");
            break;
          }
          node = node.parentElement;
        }
      });

      // ── Cart page fee line: <tr> before <tr class="cart-subtotal"> ────

      var subtotalTr = document.querySelector("tr.cart-subtotal");
      if (subtotalTr && !document.getElementById(FEE_ID)) {
        var tr = document.createElement("tr");
        tr.id = FEE_ID;
        tr.innerHTML = '<th style="font-weight:400;font-size:13px;color:#555;">' + FEE_LABEL + '</th>' +
                       '<td style="text-align:right;font-size:13px;color:#111;font-weight:600;">' +
                         '<span class="price">' + formatMoney(totalCents) + '</span>' +
                       '</td>';
        subtotalTr.parentElement.insertBefore(tr, subtotalTr);
      }

      // Fee line in cart drawer: inject into .side-panel-footer
      var drawerFooter = document.querySelector("#Cart-Drawer .side-panel-footer");
      if (drawerFooter && !drawerFooter.querySelector("#" + FEE_ID_DR)) {
        var div = document.createElement("div");
        div.id = FEE_ID_DR;
        // Use same class structure as the subtotal row so theme styles apply automatically
        div.className = "mini-cart__row";
        div.innerHTML = '<div class="mini-cart__label">' + FEE_LABEL + '</div>' +
                        '<span class="amount">' + formatMoney(totalCents) + '</span>';
        // Insert right before the subtotal row, not at the top of the footer
        var drawerSubtotal = drawerFooter.querySelector(".mini-cart__total");
        if (drawerSubtotal) {
          drawerFooter.insertBefore(div, drawerSubtotal);
        } else {
          drawerFooter.appendChild(div);
        }
      }

    }).catch(function () {});
  }

  function removeFeeLine(id) {
    var el = document.getElementById(id);
    if (el) el.remove();
  }

  // ── Re-run after cart re-renders ──────────────────────────────────────────

  var debounceTimer;
  function schedule() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(process, 120);
  }

  var observer = new MutationObserver(schedule);

  function observe(el) {
    if (el) observer.observe(el, { childList: true, subtree: true });
  }

  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var p = _fetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) p.then(schedule, schedule);
    return p;
  };

  // ── Init ──────────────────────────────────────────────────────────────────

  function init() {
    process();
    observe(document.getElementById("Cart-Drawer"));
    if (window.location.pathname === "/cart") {
      observe(document.querySelector("#Cart, .thb-cart-form"));
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
